import privacyPolicyContent from "./content/privacy-policy.json";

export const privacyPolicyMock = {
  name: "privacy-policy",
  layoutType: 1,
  areasList: [
    {
      id: "privacy-policy-1",
      name: "privacy-policy-content",
      componentName: "Comp:PrivacyPolicyPage",
      content: JSON.stringify(privacyPolicyContent),
    },
  ],
};
